import { DashboardModel } from '../types';

export const createDashboardModel = (
  defaults?: Partial<DashboardModel>
): DashboardModel => {
  return {
    __typename: 'Dashboard',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    ...defaults,
    id: defaults?.id || '',
  };
};
